require('firebase/firestore');
const app = require('../app');
let db = app.firestore();

if (process.env.NODE_ENV == 'test' || process.env.NODE_ENV == 'development')
  db.settings({
    host: 'localhost:8080',
    ssl: false,
  });

module.exports = db;
